import type { AuthenticationDto } from "@/models/authenticationDto";
import type { TokenAuthDto } from "@/models/dto/tokenAuthDto";
import type { TokenContextualAuthDto } from "@/models/dto/tokenContextualAuthDto";
import axios, { type AxiosResponse } from "axios";

export const authenticate = async (
  tokenAuth: TokenAuthDto
): Promise<AxiosResponse> => await axios.post("/api/authenticate", tokenAuth);

export const contextuallyAuthenticate = async (
  tokenAuth: TokenContextualAuthDto
): Promise<AxiosResponse> =>
  await axios.post("/api/contextual-authentication", tokenAuth);

export const sendToken = async (email: string): Promise<void> => {
  await axios.post("/api/authenticate/send-token", { email });
};

export const sendContextToken = async (
  context: string,
  email: string
): Promise<void> => {
  await axios.post("api/contextual-authentication/send-token", {
    context,
    email,
  });
};

export const getAuthenticationStatus = async (): Promise<AuthenticationDto> => {
  const resp = await axios.get<AuthenticationDto>("/api/authenticate/status");
  return resp.data;
};

export const logout = () => (window.location.href = "/api/authenticate/logout");
